import { getLotteryPurchaseSummaryItems, type SummaryItemDescriptor } from '../extras';
import type { LotteryName, Participation, RenewType } from '../types';
import { getOptionSummaryItems } from './optionItems';
import { getTicketSummaryItems } from './ticketItems';

type PurchaseData = {
  lotteryName: LotteryName;
  renewType?: RenewType;
  duration: number;
  lineCount: number;
  dyjPlayed: boolean;
  options: string[];
  participation: Participation;
  numberOfDraws: number;
};

function getPurchaseSummaryItems(data: PurchaseData): SummaryItemDescriptor[] {
  const { participation, ...ticket } = data;

  return [...getTicketSummaryItems(ticket), ...getOptionSummaryItems(data.options), ...getLotteryPurchaseSummaryItems({ ticket, participation })];
}

export { getPurchaseSummaryItems, type PurchaseData };
